var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _g3, _g4, _g5, _g6, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ValApartment_svg__Ebene_1",
    viewBox: "188 105.5 348 414"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window-1-5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M316 423.6h32.8v32.8H316z",
    paintOrder: "fill markers stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__door-1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M228.7 419.3h42.7v98.3h-42.7z",
    paintOrder: "fill markers stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window-1-4",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M316 322.2h32.8V355H316z",
    paintOrder: "fill markers stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__balcony-2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M208.9 354.2h78.7v38.3h-78.7z",
    paintOrder: "fill markers stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window-1-3",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M233.2 321.3H266v32.8h-32.8z",
    paintOrder: "fill markers stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window-1-2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M316 215.1h32.8v32.8H316z",
    paintOrder: "fill markers stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__balcony-1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M208.9 247.7h78.7V286h-78.7z",
    paintOrder: "fill markers stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window-1-1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M235.2 215H268v32.8h-32.8z",
    paintOrder: "fill markers stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__house-1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M190.1 184.1h183v333.6h-183z",
    paintOrder: "fill markers stroke"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__window-big"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M209.6 198.7h140.1v95.1H209.6z",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__window-big-inner-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__path1553",
    fill: "#1d1d1c",
    d: "M272.1 236.7l-1.3-.1-1.5.1-1.5.2-1.4.4c-1.8.6-3.6 1.5-5 2.8l-1 1.1-.5.5-.4.6-.8 1.2-.7 1.4c-.3.4-.4.9-.6 1.4l-.5 1.5-.7 3.1-.5 1.8-.6 1.7-1.4 3.3c-1 2.2-2.3 4.2-3.9 6.1a17.8 17.8 0 01-5.9 4.6 15.6 15.6 0 01-7.5 1c-.9-.1-1.5-.9-1.4-1.8.1-.9.9-1.5 1.8-1.4h3c1-.2 1.9-.4 2.8-.8 1.7-.8 3.3-2.1 4.6-3.7a24 24 0 003.2-5.4l1.2-3c.3-1 .7-2.1.8-3 .7-4.6 2.4-9.5 6.1-13.2 1.8-1.8 4.1-3.2 6.6-4l1.9-.5 1.9-.3 1.9-.1 2 .1c1.3.1 2.2 1.3 2 2.5a2.2 2.2 0 01-2.5 2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__window-big-inner-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line1557",
    fill: "none",
    stroke: "#1d1d1c",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.8,
    d: "M302.4 205v84.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__Wohnung_Erdgeschoss_Gartenstrich1",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line879",
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.8,
    d: "M943.5 384.3L892.9 452",
    transform: "matrix(-.7667 .56678 .60279 .42724 866.3 -181.9)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__Wohnung_Erdgeschoss_Gartenstrich2",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line887",
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.8,
    d: "M943.5 384.3L892.9 452",
    transform: "matrix(-.7667 .56678 .60279 .42724 945.8 -181.6)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__tree"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__g1584"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line1582",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.2,
    d: "M504 478.3v36.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__path1586",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.2,
    d: "M506.8 480.9a36 36 0 01-16.5-2.2c-5.1-2.3-9.2-7.6-8.4-13.2.4-3.1 2.3-6.2 1.4-9.2-1-3-4-4.4-6.3-6.6-5-5-3.8-14 1.1-19.2 5-5.2 12.5-7 19.6-7 4 0 8.1.5 11.8 2.2 3.6 1.7 6.7 4.7 7.9 8.5 2 6.6-2.1 13.8-.2 20.5.5 1.7 1.3 3.3 1.9 5 1.5 4.8.9 10-1.9 14.3-2.5 3.9-8.8 6.3-13.8 7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__bicycle",
    transform: "translate(-813 131.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ValApartment_svg__circle1625",
    cx: 1232,
    cy: 370.8,
    r: 11.8,
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ValApartment_svg__circle1627",
    cx: 1274,
    cy: 370.8,
    r: 11.8,
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line1629",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "M1243.8 350.2l-11.8 19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__polyline1631",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "M1266.6 347.8l-16.1 21.8-8.8-25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line1633",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "M1273.8 369.6l-7.9-23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line1635",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "M1260 345.5h11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__line1637",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "M1237.5 344h7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "ValApartment_svg__house2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__house-2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M373.1 300.6h160.6v217H373.1z",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__door-2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M399.3 419.3H442v98.3h-42.7z",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window-2-2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M480.3 327.2h32.8V360h-32.8z",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__window-2-1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M403.3 327.2h32.8V360h-32.8z",
    paintOrder: "fill markers stroke"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ValApartment_svg__roof",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4.3,
    d: "M373.9 183.6l-183.8.5 93-76z",
    paintOrder: "fill markers stroke"
  })));
}
export default SvgValApartment;